import { PayloadAction } from "@reduxjs/toolkit";
import { ReduxHelper } from "helpers";
import { IBaseReducerState } from "helpers/reduxHelpers";
import { CompanyActions } from "redux/actions";

interface ICompanyState extends IBaseReducerState {}

const initialState: ICompanyState = {
  action: CompanyActions.prefix,
  prefix: CompanyActions.prefix,
};

const clearAction = (state: ICompanyState, action: PayloadAction) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.action = CompanyActions.prefix;
  });

const UserReducer = ReduxHelper.createHandleReducer<ICompanyState>(
  initialState,
  (builder) => {
    builder.addCase(CompanyActions.clearAction.request, clearAction);
  }
);

export default UserReducer;
